module.exports = __webpack_public_path__ + "img/constr.f80ffd71.png";